import { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { getToken, hasExpiredToken } from 'common/user';

export function requestInterceptor(config: InternalAxiosRequestConfig): AxiosRequestConfig {
  const token = getToken();
  if (token && !hasExpiredToken()) {
    config.headers!.Authorization = `Bearer ${token}`;
  }
  return config;
}

export function responseInterceptor({ data }: AxiosResponse) {
  return data;
}
